import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import WorkCaseSubNav from './workcase/WorkCaseSubNav';

import Sidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar 
        userType={user?.role} 
        isOpen={sidebarOpen} 
        onToggle={() => setSidebarOpen(!sidebarOpen)} 
      />
      
      {/* Main content */}
      <div className="lg:pl-64">
        <main className="py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {/* Work Cases sub-navigation (shows only on /work-cases/*) */}
            <WorkCaseSubNav />
            {children ? children : <Outlet />}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout; 
